import React from 'react';

const TechieScoreGauge = ({ score, size = 80, summary }) => {
  const percentage = (score / 10) * 100;
  const strokeDasharray = 2 * Math.PI * 30; // Circle circumference
  const strokeDashoffset = strokeDasharray - (strokeDasharray * percentage) / 100;
  
  // Color based on score
  const getScoreColor = (score) => {
    if (score <= 3) return '#EF4444'; // Red
    if (score <= 6) return '#F97316'; // Orange  
    if (score <= 8) return '#22C55E'; // Green
    return '#3B82F6'; // Blue
  };

  const getScoreLabel = (score) => {
    if (score <= 3) return 'Poor';
    if (score <= 6) return 'Moderate';
    if (score <= 8) return 'Good';
    return 'Excellent';
  };

  const color = getScoreColor(score);
  const label = getScoreLabel(score);

  return (
    <div className="flex flex-col items-center group relative">
      <div className="relative" style={{ width: size, height: size }}>
        <svg
          width={size}
          height={size}
          viewBox="0 0 80 80"
          className="transform -rotate-90"
        >
          {/* Background circle */}
          <circle
            cx="40"
            cy="40"
            r="30"
            fill="none"
            stroke="currentColor"
            strokeWidth="8"
            className="text-gray-200 dark:text-gray-700"
          />
          
          {/* Progress circle */}
          <circle
            cx="40"
            cy="40"
            r="30"
            fill="none"
            stroke={color}
            strokeWidth="8"
            strokeLinecap="round"
            strokeDasharray={strokeDasharray}
            strokeDashoffset={strokeDashoffset}
            className="transition-all duration-1000 ease-out"
          />
        </svg>
        
        {/* Score text */}
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="text-lg font-bold text-gray-900 dark:text-gray-100">
            {score.toFixed(1)}
          </span>
          <span className="text-xs text-gray-500 dark:text-gray-400">
            /10
          </span>
        </div>
      </div>
      
      <div className="mt-1 text-center">
        <span 
          className="text-xs font-medium px-2 py-1 rounded-full"
          style={{ 
            color: color,
            backgroundColor: `${color}15`,
            border: `1px solid ${color}30`
          }}
        >
          {label}
        </span>
      </div>
      
      {summary && (
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 dark:bg-gray-700 text-white dark:text-gray-200 text-xs rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-10">
          {summary}
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-900 dark:border-t-gray-700"></div>
        </div>
      )}
    </div>
  );
};

export default TechieScoreGauge;